/* @flow weak */
import React from 'react';
import ReactDOM from 'react-dom';

import userAgent from 'lib/currentUserAgent';

const stack = [];

function shouldHideLayerOnEvent(layer, event) {
  if (!layer.props.hideOnBlur) {
    return false;
  }

  const context = layer.props.context;
  if (context && context.contains(event.target)) {
    return false;
  }

  const node = ReactDOM.findDOMNode(layer);
  return !node.contains(event.target);
}

function hideOnBlur(event) {
  let layersToHide = [];
  const layersToKeep = [];

  // split the layers into 2 bucket.
  let i = stack.length;
  while (i--) {
    const layer = stack[i];
    if (shouldHideLayerOnEvent(layer, event)) {
      layersToHide.push(layer);
    } else {
      layersToKeep.push(layer);
    }
  }

  // If a layer has a button that open another layer
  // then clicking inside the second layer should not close
  // the first layer.
  layersToHide = layersToHide.filter(layerToHide => {
    const contextToHide = layerToHide.props.context;

    const shouldFilterOut = layersToKeep.some(layerToKeep => {
      const nodeToKeep = ReactDOM.findDOMNode(layerToKeep);
      return !nodeToKeep.contains(contextToHide);
    });

    return !shouldFilterOut;
  });

  layersToHide.forEach(layer => {
    // Enqueue this at the end of the event queue to allow click events to fire in I
    setTimeout(layer.props.onRequestHide, 0);
  });
}

const LayerHideOnBlur = {
  propTypes: {
    hideOnBlur: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      hideOnBlur: true,
    };
  },

  componentDidMount() {
    if (stack.length === 0) {
      if (userAgent.firefox()) {
        document.addEventListener('focus', hideOnBlur, true);
      } else {
        document.addEventListener('focusin', hideOnBlur, false);
      }
      document.addEventListener('mousedown', hideOnBlur, false);
    }

    stack.push(this);
  },

  componentWillUnmount() {
    const index = stack.indexOf(this);
    if (index >= 0) {
      stack.splice(index, 1);

      if (stack.length === 0) {
        if (userAgent.firefox()) {
          document.removeEventListener('focus', hideOnBlur, true);
        } else {
          document.removeEventListener('focusin', hideOnBlur, false);
        }
        document.removeEventListener('mousedown', hideOnBlur, false);
      }
    }
  },
};

export default LayerHideOnBlur;



// WEBPACK FOOTER //
// ./src/components/mixins/LayerHideOnBlur.js